export default "__VITE_ASSET__6451b7cc__"